import React from 'react';
import { IOffer } from '../../types';

import * as styles from './styles.css';
import { Image, UIHeading4, UIText1 } from '@cian/ui-kit';
import { formatNumberWithSpaces, transformNumToString, trimToDecimals } from '../../../common/utils';
import { isNil } from 'ramda';
import { NBSP, PERCENT, RUB } from '../../../common/constants';
import { LabelComponent } from './components/LabelComponent';
import { ETestIds } from '../../constants';

export interface IOfferCardProps {
  offer: IOffer;
  onClick: () => void;
}

export const OfferCard: React.FC<IOfferCardProps> = ({ offer, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={styles['container']}
      data-testid={`${ETestIds.OfferCard} ${ETestIds.OfferCard}-${offer.type}`}
    >
      <div className={styles['wrapper']}>
        <div className={styles['bank-block']}>
          <div className={styles['bank-block__bank']}>
            <div className={styles['bank-block__icon']}>
              <Image
                src={offer.iconPath}
                title={offer.offerName}
                borderRadius={'50%'}
                alt={offer.offerName}
                preloader
              />
            </div>
            <div className={styles['bank-block__text']}>
              <UIHeading4 color={'text-primary-default'}>{offer.offerName}</UIHeading4>
              <UIText1 color={'text-primary-default'}>{offer.offerDescription}</UIText1>
            </div>
          </div>

          <div className={styles['bank-block__psk']}>
            <div className={styles['psk-block']}>
              <UIText1 color={'text-secondary-default'}>
                {!isNil(offer.psk)
                  ? transformNumToString(+offer.psk.from) + '—' + transformNumToString(+offer.psk.to) + PERCENT
                  : ''}
              </UIText1>
            </div>
          </div>
        </div>

        <div className={styles['info-block']}>
          <div className={styles['rate-block']}>
            <UIText1 color={'text-primary-default'}>
              {transformNumToString(trimToDecimals(Number(offer.rate))) + PERCENT}
            </UIText1>
          </div>

          <div className={styles['payment-block']}>
            <UIText1 color={'text-primary-default'}>
              {'от' + NBSP + formatNumberWithSpaces(offer.monthlyPayment) + NBSP + RUB}
            </UIText1>
          </div>

          <div className={styles['label-block']}>
            <LabelComponent text={offer.label} />
          </div>
        </div>
      </div>
    </div>
  );
};
